import { ThemedText, ThemedView } from '@app/theme'
import InputText from '@app/sharedComponents/TextInput/TextInput'
import { useState } from 'react'
import Button from '@app/sharedComponents/Button/Button'
import { formatIndianCurrency } from '@app/utils/utility'
import useIsMobileBrowser from '@app/hooks/useIsMobileBrowser'
import { Platform } from 'react-native'


const EditAmountModal = ({initialAmount , onChange , minAmount , maxAmount}: {initialAmount: number, onChange: (amount: number) => void, minAmount: number, maxAmount: number}) => {

    const [editAmount, setEditAmount] = useState(initialAmount?.toString() || '');
    const isMobileBrowser = useIsMobileBrowser()

    const error = parseInt(editAmount) < minAmount || parseInt(editAmount) > maxAmount || !editAmount
    const errorMessage = error && (parseInt(editAmount) < minAmount || !editAmount) ? `Minimum credit limit allowed is ₹${formatIndianCurrency(minAmount)}` : `Maximum credit limit allowed is ₹${formatIndianCurrency(maxAmount)}`

    return (
        <ThemedView padding='lg'>
            <ThemedText mb='sm' variant='h5s' color='text-primary'>Select the credit limit amount</ThemedText>
            <InputText
                keyboardType="phone-pad"
                value={editAmount}
                onChangeText={(text) => {
                    // Only allow numeric input
                    const numericValue = text.replace(/[^0-9]/g, '');
                    setEditAmount(numericValue)
                }}
                showAnimation
                showLabel
                label={'Credit limit'}
                autoFocus={true}
            />  
            <ThemedText mt='sm' variant='b4r' color='text-error'>{error ? errorMessage : ' '}</ThemedText>
            <ThemedView mt="xl">
                <Button
                eventName='SET_CREDIT_LIMIT_EDITAMOUNT_AMOUNTCONFIRM_CLICKED'
                additionalProperties={{minAmount, maxAmount}}
                    size='MD'
                    label={'Confirm'}
                    handlePress={() => {
                        // Analytics fired by the parent's `onChange`
                        // (SETLIMIT_EDITAMOUNT_AMOUNTCONFIRM_CLICKED).
                        onChange(editAmount ? parseInt(editAmount) : 0)
                    }}
                    type={'SOLID'}
                    disabled={error || !editAmount}
                    buttonLoader={false}
                />
            </ThemedView>
            {isMobileBrowser && <ThemedView height={20} />}
            {Platform.OS !== 'web' && (
                <ThemedView height={20} />
            )}
        </ThemedView>
    )
}

export default EditAmountModal